document.addEventListener('DOMContentLoaded', () => {
  const rails = document.querySelectorAll('.pdp-main .thumbnail-slider');

  rails.forEach((rail) => {
    const list = rail.querySelector('.thumbnail-list');
    const upButton = rail.querySelector('.pdp-thumb-arrow--up');
    const downButton = rail.querySelector('.pdp-thumb-arrow--down');
    if (!list || !upButton || !downButton) return;

    let animationId = null;
    let pendingTarget = null;

    const scrollStep = () => {
      const item = list.querySelector('.thumbnail-list__item');
      return item ? item.getBoundingClientRect().height + 12 : 92;
    };

    // scrollBy/scrollTo with behavior:'smooth' never runs on this list in
    // Chromium, so the easing is done manually via rAF.
    const animateTo = (target) => {
      if (animationId) cancelAnimationFrame(animationId);
      const start = list.scrollTop;
      const distance = target - start;
      const startTime = performance.now();
      const duration = 300;
      pendingTarget = target;
      const tick = (now) => {
        const progress = Math.min(1, (now - startTime) / duration);
        list.scrollTop = start + distance * (1 - Math.pow(1 - progress, 3));
        if (progress < 1) {
          animationId = requestAnimationFrame(tick);
        } else {
          animationId = null;
          pendingTarget = null;
        }
      };
      animationId = requestAnimationFrame(tick);
    };

    const stepScroll = (direction) => {
      const step = scrollStep();
      const maxScroll = list.scrollHeight - list.clientHeight;
      const from = pendingTarget !== null ? pendingTarget : list.scrollTop;
      const aligned = Math.round(from / step) * step;
      animateTo(Math.max(0, Math.min(maxScroll, aligned + direction * step)));
    };

    const syncArrows = () => {
      const scrollable = list.scrollHeight > list.clientHeight + 1;
      rail.classList.toggle('thumbnail-slider--static', !scrollable);
      upButton.hidden = !scrollable;
      downButton.hidden = !scrollable;
      if (!scrollable) return;
      upButton.toggleAttribute('disabled', list.scrollTop <= 0);
      downButton.toggleAttribute('disabled', list.scrollTop + list.clientHeight >= list.scrollHeight - 1);
    };

    upButton.addEventListener('click', () => stepScroll(-1));
    downButton.addEventListener('click', () => stepScroll(1));

    list.addEventListener('scroll', syncArrows);
    new ResizeObserver(syncArrows).observe(list);
    syncArrows();
  });
});
